import CircleIcon from "@mui/icons-material/Circle";
import RowContainer from "../../components/common/RowContainer";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/features/language/languageSlice";
import { translateStatusString } from "../../utils/helpers/translateStatusString";

export const RenderColoredCircleIconWithStatus = ({ string }) => {
  const currentLanguage = useSelector(selectLanguage);

  const handleFromCamelCaseToNormal = (str) => {
    const translatedString = translateStatusString(str, currentLanguage);
    return translatedString
      .replace(/_/g, " ") // replace underscores with spaces
      .replace(/([A-Z])/g, " $1") // add space before capital letters
      .replace(/^./, function (str) {
        return str.toUpperCase();
      });
  };

  let color;

  switch (string) {
    case "completed":
    case "active":
      color = "var(--success)";
      break;
    case "pending":
      color = "var(--pending)";
      break;
    case "banned":
    case "failed":
      color = "var(--error)";
      break;
    case "new":
      color = "var(--info)";
      break;
    case "refunded":
      color = "var(--refunded)";
      break;
    case "in_progress":
      color = "var(--progress)";
      break;
    case "closed":
      color = "var(--closed)";
      break;
    default:
      color = "var(--info)";
  }
  return (
    <RowContainer start minGap align="center">
      <CircleIcon fontSize="small" sx={{ "& path": { color: color } }} />
      {handleFromCamelCaseToNormal(string)}
    </RowContainer>
  );
};
